import { Routes, Route } from "react-router-dom";
import LoginPage from "views/auth/signIn";
import UploadFilePage from "views/admin/uploadFilePage";
import CheckDownloadData from "views/admin/checkDownloadData";
import GetClaimPage from "views/admin/getClaimPage";
import CheckClaimDataPage from "views/admin/checkClaimDataPage";
import AnalyticsPage from "views/admin/AnalyticsPage";
import InternetConnectivityChecker from "components/InternetChecker";
import React from "react";
import TrifectaPage from "views/admin/tifectaPage";
import ChatBotPage from "views/admin/chatBotPage";
import StoragePage from "views/upload";
import SelectModulePage from "views/moduleFlow/SelectModulePage";
import ModuleFilesUploadPage from "views/moduleFlow/ModuleFilesUploadPage";
import ProtectedRoute from "components/ProtectedRoute";

// ...existing code...

import ClassificationUploadFilesPage from "views/documentClassfication/classificationUploadFiles";

export function Main() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/select-module-page"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <SelectModulePage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/document-classification"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <ClassificationUploadFilesPage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/module-files-upload-page"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <ModuleFilesUploadPage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/check-data"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <CheckDownloadData />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/claim"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <GetClaimPage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/report"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <CheckClaimDataPage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/analytics"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <AnalyticsPage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/trifecta"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <TrifectaPage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/chat-page"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <ChatBotPage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
      <Route
        path="/storage-page"
        element={
          <ProtectedRoute
            element={
              <InternetConnectivityChecker>
                <StoragePage />
              </InternetConnectivityChecker>
            }
          />
        }
      />
    </Routes>
  );
}
